module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-body"
  }, [_c('div', {
    staticClass: "c-body__title"
  }, [_c('h2', [_c('span', [_vm._v("Zen2Han")]), _vm._v(" "), _c('button', {
    class: {
      '-active': _vm.showHelp
    },
    on: {
      "click": _vm.toggleHelp
    }
  }, [_c('c-icon', {
    attrs: {
      "name": 'question-circle'
    }
  })], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-body__inner"
  }, [_c('div', {
    staticClass: "e-section"
  }), _vm._v(" "), _c('div', {
    staticClass: "e-section"
  }, [_c('div', {
    staticClass: "c-zen2han-app"
  }, [_c('div', {
    staticClass: "e-grid -double"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "c-zen2han-app__title"
  }, [_c('h3', [_vm._v("INPUT")]), _vm._v(" "), _c('div', {
    staticClass: "e-label-list"
  }, [_c('label', {
    staticClass: "e-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.number),
      expression: "options.number"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.number) ? _vm._i(_vm.options.number, null) > -1 : (_vm.options.number)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.options.number,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.options.number = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.options.number = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.options.number = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("数字")])]), _vm._v(" "), _c('label', {
    staticClass: "e-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.alphabet),
      expression: "options.alphabet"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.alphabet) ? _vm._i(_vm.options.alphabet, null) > -1 : (_vm.options.alphabet)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.options.alphabet,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.options.alphabet = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.options.alphabet = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.options.alphabet = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("アルファベット")])]), _vm._v(" "), _c('label', {
    staticClass: "e-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.space),
      expression: "options.space"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.space) ? _vm._i(_vm.options.space, null) > -1 : (_vm.options.space)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.options.space,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.options.space = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.options.space = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.options.space = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("空白")])]), _vm._v(" "), _c('label', {
    staticClass: "e-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.symbol),
      expression: "options.symbol"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.symbol) ? _vm._i(_vm.options.symbol, null) > -1 : (_vm.options.symbol)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.options.symbol,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.options.symbol = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.options.symbol = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.options.symbol = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("記号")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-zen2han-app__editor",
    attrs: {
      "id": "zen2han-input"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "c-zen2han-app__title"
  }, [_c('h3', [_vm._v("OUTPUT")]), _vm._v(" "), _c('button', {
    staticClass: "e-button",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("クリップボードにコピー")])]), _vm._v(" "), _c('div', {
    staticClass: "c-zen2han-app__editor",
    attrs: {
      "id": "zen2han-output"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-help"
  }, [_c('div', {
    staticClass: "c-help__inner"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t文字列中の全角文字を半角文字に変換します。"), _c('br'), _vm._v("\n\t\t\t\t\t変換する文字種は数字・アルファベット・空白・記号の中から任意に選択できます。"), _c('br'), _vm._v("\n\t\t\t\t\tエンジニアをぜったいにころすコードをころすために生まれました。\n\t\t\t\t")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1223fdc0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/page/zen2han.vue
// module id = 58
// module chunks = 0